import { Component, Vue } from "vue-property-decorator";

@Component
export class MdParserMixin extends Vue {
  public toBold(message: string | null) {
    if (!message) return;
    return message.replace(/[\*\_]{2}([^\*\_]+)[\*\_]{2}/g, "<b>$1</b>");
  }
}
